import type { SlideConfig, WrappedData } from '../types/wrapped'

export const WRAPPED_SLIDES: Array<SlideConfig> = [
  {
    id: 'intro',
    type: 'intro',
    duration: 8000,
    video: {
      id: '1152033796',
      aspectRatio: '9:16',
    },
  },
  {
    id: 'personality',
    type: 'personality',
    duration: 9000,
  },
  {
    id: 'destinations',
    type: 'stat',
    duration: 8000,
  },
  {
    id: 'nights',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151421758',
      aspectRatio: '9:16',
    },
  },
  {
    id: 'distance',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151431656',
      aspectRatio: '9:16',
    },
  },
  {
    id: 'top-destinations-quiz',
    type: 'quiz',
    duration: 7000,
  },
  {
    id: 'offer-views',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151421744',
      aspectRatio: '9:16',
    },
  },
  {
    id: 'top-offer',
    type: 'offer',
    duration: 9000,
  },
  {
    id: 'savings',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151421772',
      aspectRatio: '9:16',
    },
  },
  {
    id: 'loyalty',
    type: 'loyalty',
    duration: 9000,
  },
  {
    id: 'summary',
    type: 'summary',
    duration: 11000,
  },
  {
    id: 'prediction',
    type: 'prediction',
    duration: 9000,
    video: {
      id: '1151421780',
      aspectRatio: '9:16',
    },
  },
]

/**
 * Returns the filtered slides based on user data conditions
 */
export function getActiveSlides(data: WrappedData): Array<SlideConfig> {
  return WRAPPED_SLIDES.filter((slide) => {
    switch (slide.id) {
      case 'top-destinations-quiz':
        return data.topDestinations.length >= 3
      case 'loyalty':
        return !!data.loyalty?.points || data.loyalty?.statusCredits
      case 'top-offer':
        return !!data.topOffer.imageId.length
      default:
        return true
    }
  })
}
